import { ActionType } from "../../model/actionTypes";
import {errorHandler} from "./auth";


export const getHelpById = (params: any) => async (dispatch: Function, getState: Function, api: any) => {
    let stringifyParams;
    if(params){
        stringifyParams = '/'+JSON.stringify(params)
    }
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp =  await api.get("helpMark"+stringifyParams);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        return dispatch(errorHandler(err));
    }
};


export const getHelpNotifications = (id: any) => async (dispatch: Function, getState: Function, api: any) => {

    try {
        const resp =  await api.get("helpMark/notifications/"+id);
        return resp;
    } catch (err) {
         return dispatch(errorHandler(err));
    }
};

export const updateHelpNotifications = (obj: object) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp =  await api.put("helpMark/notifications", obj);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        return dispatch(errorHandler(err));
    }
};




